import styled, { css } from "styled-components";
import { up } from "styled-breakpoints";
import Link from "../../Link";

interface MetaWrapperProps {
  position?: string;
}

export const HeaderContainer = styled.div`
  padding-bottom: 1rem;
`;

export const Container = styled.div`
  position: relative;
  max-width: 1440px;
  margin: auto;
  width: 100%;
  height: 0;
  padding-bottom: min(50%, 44.125rem);
  overflow: hidden;
`;

export const SubContainer = styled.div`
  position: absolute;
  inset: 0;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  border-bottom-left-radius: 20% 41%;
  // border-bottom-right-radius: 20% 41%;
  height: 0;
  padding-bottom: min(50%, 44.125rem);
`;

export const MetaContainer = styled.div`
  position: absolute;
  inset: 0;

  ${up("tablet-portrait")} {
    inset: 3rem 4.5rem 3rem;
  }

  ${up("tablet-landscape")} {
    inset: 3rem 6.5rem 3.7rem;
  }

  ${up("laptop")} {
    inset: 5rem 7.5rem 5rem;
  }
`;

const left = css`
  justify-content: center;
  max-width: 100%;
  align-items: flex-start;
`;

const right = css`
  justify-content: center;
  max-width: 50%;
  margin-left: auto;
`;

const bottom = css`
  justify-content: flex-end;
  align-items: center;
`;

const center = css`
  justify-content: center;
  align-items: center;
`;

const top = css`
  justify-content: flex-start;
  align-items: center;
`;

export const MetaWrapper = styled.div<MetaWrapperProps>`
  position: relative;
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;

  ${({ position }) => {
    if (position === "top") return top;
    else if (position === "left") return left;
    else if (position === "right") return right;
    else if (position === "bottom") return bottom;
    return center;
  }}
`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileImageContainer = styled.div`
  border-bottom-right-radius: 32% 30%;
  overflow: hidden;
  position: relative;
`;

// REPLACE FOR GLOBAL BUTTON COMPONENT;

interface ButtonProps {
  color: string;
}

export const Button = styled(Link)<ButtonProps>`
  background-color: ${({ theme, color }) => theme.colors[color]};
  color: ${({ theme, color }) => (color === "navy" ? theme.colors.offWhite : theme.colors.navy)};
  padding: 0.9rem 2.4rem;
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.helvetica};
  text-align: center;
  outline: 1px solid ${({ theme, color }) => theme.colors[color]};
  transition: all 0.1s ease-in-out;

  ${up("tablet-portrait")} {
    width: fit-content;
  }

  &:visited {
    color: ${({ theme, color }) => (color === "navy" ? theme.colors.offWhite : theme.colors.navy)};
  }

  &:hover,
  focus {
    background-color: ${({ theme, color }) =>
      color === "navy" ? theme.colors.offWhite : theme.colors[color]};
    color: ${({ theme, color }) => (color === "navy" ? theme.colors[color] : theme.colors.gold)};
  }
`;

export const TitleContainer = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
`;
